import React, { Dispatch, PropsWithChildren, useState } from 'react';
import { IPageInfo } from '../interfaces/app-interfaces';
import { IChatCaseData, IChatQueueType } from '../interfaces/case-details-api-interfaces';

export interface ICaseDataContextState {
  pageInfo?: IPageInfo;
  caseData?: IChatCaseData;
  queueType: IChatQueueType;
}

interface ICaseDataContextProps {
  state: ICaseDataContextState;
  setState: Dispatch<React.SetStateAction<ICaseDataContextState>>;
}

const CaseDataContext = React.createContext<ICaseDataContextProps>({
  state: { queueType: 'default' },
  setState: () => {},
});
const CaseDataProvider: React.FC<PropsWithChildren<{ data?: ICaseDataContextState }>> = ({ children, data }) => {
  const [state, setState] = useState<ICaseDataContextState>({
    pageInfo: data?.pageInfo,
    queueType: 'default',
  });
  return (
    <CaseDataContext.Provider
      value={{
        state,
        setState,
      }}
    >
      {children}
    </CaseDataContext.Provider>
  );
};
export { CaseDataContext, CaseDataProvider };
